// Libs
import React, { Component } from 'react'
import { LineChart, XAxis, Tooltip, CartesianGrid, ReferenceLine, Line, ResponsiveContainer } from 'recharts'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import DashboardLineTooltip from '../DashboardLineTooltip'
import DashboardPill from '../DashboardPill'
import DashboardTitle from '../DashboardTitle'

class DashboardLine extends Component {
  state = {
    data: [],
    median: '',
    option: {},
    options: [
      { label: 'PERFOMANCE', value: 'performance', median: 0, benchmark: 40, unit: '%' },
      { label: 'COM SUCESSO', value: 'successful', median: 0, unit: '' },
      { label: 'INSERÇÕES', value: 'entries', median: 0, unit: '' }
    ],
  }

  UNSAFE_componentWillMount() {
    const { options } = this.state

    this.setState({ option: options[0] })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data, relativeMedians } = this.props
    const { data: nextData, relativeMedians: nextRelativeMedians } = nextProps
    const { option } = this.state
    const { composeData } = this

    if (data !== nextData) {
      composeData(nextData, option, nextRelativeMedians)
    }
  }

  composeData = (data, option, relativeMedians) => {
    let composedData = []
    let values = 0

    data.map(item => {
      const value = option.unit === '%' ? Math.round(item[option.value] * 100) : item[option.value]

      values += parseInt(value)
      composedData = [...composedData, { name: item.label, value: parseInt(value) }]
    })

    this.setState({
      composedData,
      median: relativeMedians[option.value] ? Math.round(relativeMedians[option.value] * 100) : Math.round(values / data.length)
    })
  }

  findRadius = () => {
    const { data } = this.props

    if (data.length >= 90) return 3
    if (data.length >= 60) return 4
    if (data.length >= 30) return 5

    return 7
  }

  render() {
    const { data, period, relativeMedians } = this.props
    const { composedData, median, option, options } = this.state
    const { composeData, findRadius } = this

    return (
      <div className="dashboard-line">
        <div className="dashboard-line__header">
          <DashboardTitle title={`${!_.isEmpty(period.selected) ? period.selected[0].label : 'Últimos 30 Dias'}`} subTitle={option.label} />
          <DashboardPill
            option={option}
            options={options}
            onClick={option => {
              composeData(data, option, relativeMedians)
              this.setState({ option })
            }} />
        </div>
        <ResponsiveContainer width="100%" height={350}>
          <LineChart
            data={composedData}
            margin={{ top: 30, left: 40, right: 40 }}>
            <Tooltip
              animationDuration={500}
              content={<DashboardLineTooltip median={median} benchmark={option.benchmark} unit={option.unit} />}
            />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              dy={10} />
            <CartesianGrid stroke="#F2F2F2" />
            {median && <ReferenceLine y={median} stroke="#4C4C4C" />}
            {median && option.benchmark && <ReferenceLine y={option.benchmark} stroke="#12B7A3" />}
            <Line
              animationDuration={1200}
              dataKey="value"
              stroke="#D9D9D9"
              strokeWidth="2"
              activeDot={{ r: findRadius(), stroke: "#12B7A3", strokeWidth: 3, fill: 'white' }}
              dot={({ r: findRadius(), stroke: "#4C4C4C", strokeWidth: 3 })} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

export default DashboardLine
